<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-row>
                      <b-col lg="10" sm="12">
                        <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="org_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                plain
                                v-model="manageExpenses.org_id"
                                :options="orgList"
                                id="org_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Committee Id" vid="cmt_committee_id" rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="cmt_committee_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('committee.committee')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                plain
                                v-model="manageExpenses.cmt_committee_id"
                                :options="committeeList"
                                id="cmt_committee_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Agenda" vid="cmt_agenda_id" rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="cmt_agenda_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('committee.select_agenda')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                plain
                                v-model="manageExpenses.cmt_agenda_id"
                                :options="agendaList"
                                id="cmt_agenda_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Fiscal Year" vid="fiscal_year" rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="fiscal_year"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                plain
                                v-model="manageExpenses.fiscal_year"
                                :options="fiscalList"
                                id="fiscal_year"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Amount" vid="amount" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="amount"
                            slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{$t('committee.amount')}} <span class="text-danger">*</span>
                         </template>
                          <b-form-input
                              id="amount"
                              type="number"
                              v-model="manageExpenses.amount"
                              :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Expense Date" vid="date" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="date"
                            slot-scope="{ valid, errors }"
                          >
                            <template v-slot:label>
                                {{$t('committee.expense_date')}} <span class="text-danger">*</span>
                            </template>
                              <b-form-input class="form-control"
                                    v-model="manageExpenses.date"
                                    placeholder="Select Date"
                                    id="datepicker"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Description (En)" vid="description" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="description"
                            slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{$t('committee.description')}} <span class="text-danger">*</span>
                         </template>
                          <b-form-input
                              id="description"
                              v-model="manageExpenses.description"
                              :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Description (Bn)" vid="description_bn" rules="required">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="description_bn"
                            slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                            {{$t('committee.description_bn')}} <span class="text-danger">*</span>
                         </template>
                          <b-form-input
                              id="description_bn"
                              v-model="manageExpenses.description_bn"
                              :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-input>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="Attachment" vid="attachment">
                          <b-form-group
                            class="row"
                            label-cols-sm="4"
                            label-for="attachment"
                            :label="$t('committee.attachment')"
                            slot-scope="{ valid, errors }"
                          >
                            <b-form-file
                            id="attachment"
                            v-on:change="onFileChangeAttendance"
                            v-model="manageExpenses.attachment"
                            :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-file>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    <b-col class="text-right" md="12" sm='12' lg="12" xl="12">
                    <b-button type="submit" variant="primary">{{ saveBtnName}}</b-button>
                      &nbsp;
                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                    </b-col>
                    </b-row>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { commonServiceBaseUrl } from '../../../../../config/api_config'
import { manageExpensesStore, manageExpensesUpdate } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    if (this.id) {
      const tmp = this.getMeetingMinuteData()
    //   Object.freeze(tmp)
      this.manageExpenses = tmp
    }
    this.getCommitteelist()
  },
  mounted () {
    core.index()
    flatpickr('#datepicker', {})
  },
  data () {
    return {
      totalPost: 0,
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      manageExpenses: {
        org_id: 0,
        cmt_committee_id: 0,
        cmt_agenda_id: 0,
        amount: '',
        fiscal_year: 0,
        date: '',
        description: '',
        description_bn: '',
        attachment: []
      },
        attachmentDemo: [],
        committeeList: [],
        agendaList: []
    }
  },
  computed: {
    fiscalList: function () {
      const fiscalyearData = this.$store.state.commonObj.fiscalYearList
      return fiscalyearData.map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
    },
    orgList: function () {
        return this.$store.state.orgList.filter(item => item.status === 0)
    }
  },
  watch: {
    'manageExpenses.org_id': function (newVal, oldVal) {
      this.committeeList = this.getCommitteelist(newVal)
    },
    'manageExpenses.cmt_committee_id': function (newVal, oldVal) {
      this.getAgendaList(newVal)
    }
  },
  methods: {
    getMeetingMinuteData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
    onFileChangeAttendance (e) {
      this.attachmentDemo = e.target.files[0]
    },
    async register () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadinState = { loading: false, listReload: true }
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      var formData = new FormData()
      Object.keys(this.manageExpenses).map(key => {
        if (key === 'attachment') {
          formData.append(key, this.attachmentDemo)
        } else {
          formData.append(key, this.manageExpenses[key])
        }
      })
      if (this.manageExpenses.id) {
        formData.append('_method', 'PUT')
        result = await RestApi.postData(commonServiceBaseUrl, `${manageExpensesUpdate}/${this.id}`, formData)
      } else {
        result = await RestApi.postData(commonServiceBaseUrl, manageExpensesStore, formData, config)
      }
      this.$store.dispatch('mutateCommonProperties', loadinState)
        if (result.success) {
            this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
            this.$toast.success({
            title: this.$t('globalTrans.success'),
            message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
            color: '#D6E09B'
            })

            this.$bvModal.hide('modal-4')
        } else {
            this.$refs.form.setErrors(result.errors)
        }
    },
    getCommitteelist (orgId) {
        const listObject = this.$store.state.commonObjCommonConfig.cmtCommitteeList
        const committeeData = listObject.filter(committee => committee.org_id === orgId)
        return committeeData.map((obj, index) => {
            if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
            } else {
            return { value: obj.value, text: obj.text }
            }
        })
    },
    getAgendaList (comId) {
        const listObject = this.$store.state.commonObjCommonConfig.cmtAgendaList
        const agendaData = listObject.filter(agenda => agenda.cmt_committee_id === comId)
        this.agendaList = agendaData.map((obj, index) => {
            if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
            } else {
            return { value: obj.value, text: obj.text }
            }
        })
    }
  }
}
</script>
